import React, { Component } from "react";
import moment from "moment";
import {
  Navbar,
  Container,
  Row,
  Col,
  InputGroup,
  FormControl,
} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

export default class AddReceiptHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tagQty: 0,
    };

    this.onGenericChange = this.onGenericChange.bind(this);
  }

  makeInputGroup(
    id,
    labelText,
    defaultValue,
    placeholder,
    readOnly = true,
    onChangeEvent
  ) {
    return (
      <InputGroup>
        <InputGroup.Prepend>
          <InputGroup.Text>{labelText}</InputGroup.Text>
        </InputGroup.Prepend>
        <FormControl
          readOnly={readOnly}
          id={id}
          defaultValue={defaultValue}
          placeholder={placeholder ? placeholder : defaultValue}
          onChange={onChangeEvent || this.onGenericChange}
        />
      </InputGroup>
    );
  }

  onGenericChange(ev) {
    var newHeader = this.props.receiptHeader;
    if (ev.target.id === "lot"){
      newHeader.lot = ev.target.value;
    }
    else if (ev.target.id === "reference"){
      newHeader.reference = ev.target.value;
    }
    else {
      return;
    }
    this.props.onRequestHeaderChange(newHeader);
  }

  render() {
    const newTagQty = this.props.receiptHeader.tagUnitQty;
    const newPalletQty = this.props.receiptHeader.tagPalletQty;

    return (
      <Container>
        <Row>
          <Col>
            <InputGroup>
              <InputGroup.Prepend>
                <InputGroup.Text>Comments</InputGroup.Text>
              </InputGroup.Prepend>
              <FormControl
                readOnly={false}
                id="lot"
                value={this.props.receiptHeader.lot}
                onChange={this.onGenericChange}
              />
            </InputGroup>
          </Col>
          <Col>
            <InputGroup>
              <InputGroup.Prepend>
                <InputGroup.Text>Receipt Qty</InputGroup.Text>
              </InputGroup.Prepend>
              <FormControl
                readOnly={true}
                id="tagQty"
                value={newTagQty}
                onChange={this.onGenericChange}
              />
            </InputGroup>
            <InputGroup>
              <InputGroup.Prepend>
                <InputGroup.Text>Pallet Qty</InputGroup.Text>
              </InputGroup.Prepend>
              <FormControl
                readOnly={true}
                id="tagQty"
                value={newPalletQty}
                onChange={this.onGenericChange}
              />
            </InputGroup>
          </Col>
        </Row>
        <Row>
        <Col>
            <InputGroup>
              <InputGroup.Prepend>
                <InputGroup.Text>Reference</InputGroup.Text>
              </InputGroup.Prepend>
              <FormControl
                readOnly={false}
                id="reference"
                value={this.props.receiptHeader.reference}
                onChange={this.onGenericChange}
              />
            </InputGroup>
          </Col>
          <Col>
            {this.makeInputGroup(
              "receiveDateTime",
              "Date",  
              moment(this.props.receiptHeader.receiveDateTime.toString()).format("MM-DD hh:mm")
            )}
          </Col>
        </Row>
      </Container>
    );
  }
}
